import { render, staticRenderFns } from "./InboxListTransferBadge.vue?vue&type=template&id=2ac2f299"
import script from "./InboxListTransferBadge.vue?vue&type=script&lang=js"
export * from "./InboxListTransferBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports